import Vue from 'vue'
import Router from 'vue-router'
import list from '@/pages/list'
import detail from '@/pages/detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'list',
      component: list,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js